export default __webpack_public_path__ + "static/media/tea-svg2.94a9ca55.svg";